import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {HouseholdMemberDto} from "admin-api-dto";
import {TableModule} from "primeng/table";
import {TypedTableRowDirective} from "../../typed-table-row.directive";
import {LabeledComponent} from "../labeled/labeled.component";

@Component({
  selector: 'app-household-member-details',
  imports: [
    TableModule,
    TypedTableRowDirective,
    LabeledComponent
  ],
  templateUrl: './household-member-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HouseholdMemberDetailsComponent {
  public readonly householdMember = input.required<HouseholdMemberDto>();
}
